export const FETCH = "support.dashboard.FETCH";
export const FETCH_FAILED = "support.dashboard.FETCH_FAILED";
export const FETCH_OK = "support.dashboard.FETCH_OK";
